import { limitsSchema } from './bonding-line.mjs';

const POSITIVE_ERROR = "Amount must be greater than 0";
const { singleLimit, aggregateLimit } = limitsSchema.shape;
const schema = limitsSchema.safeExtend({
    singleLimit: singleLimit.refine((limit) => limit > 0, { error: POSITIVE_ERROR }),
    aggregateLimit: aggregateLimit.refine((limit) => limit > 0, { error: POSITIVE_ERROR }),
});

export { POSITIVE_ERROR, schema };
